import { Navigate } from 'react-router-dom';

import { ROUTES } from '../../constants/routes';
import { localStorageService } from '../../services/localStorageService/localStorageService';

const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const redirectUrl = localStorageService().getRedirectUrl();
  const accessToken = localStorageService().getAccessToken();

  const consumeRedirect = () => {
    localStorageService().removeRedirectUrl();
    return <Navigate to={redirectUrl as string} />;
  };

  if (window.location.pathname === '/') {
    if (redirectUrl) {
      return consumeRedirect();
    }
    // The root is the app's front door: it opens the sign-in screen for anyone
    // without a session, and drops signed-in drivers straight into their
    // cabinet. The marketing page keeps its own URL, `/landing`.
    if (!accessToken) {
      return <Navigate to={`/${ROUTES.LOGIN}`} />;
    }
    return <Navigate to={`/${ROUTES.CABINET}`} />;
  }

  if (accessToken) {
    if (redirectUrl) {
      return consumeRedirect();
    }
    return <Navigate to={`/${ROUTES.CABINET}`} />;
  }

  return <>{children}</>;
};

export default PublicRoute;
